import React from 'react';

export type BuildsMetricTileViewModel = {
  label: string;
  value: string | number;
  valueClassName: string;
  backgroundImageUrl: string | null;
};

type BuildsMetricTilesViewModel = {
  buildsMetricTiles: BuildsMetricTileViewModel[];
};

export function BuildsMetricTile({
  label,
  value,
  valueClassName,
  backgroundImageUrl,
}: BuildsMetricTileViewModel): JSX.Element {
  return (
    <div className={'builds-metric-tiles__tile'}>
      {backgroundImageUrl ? (
        <div
          className={'builds-metric-tiles__tile-background-icon'}
          style={{ backgroundImage: `url(${backgroundImageUrl})` }}
        ></div>
      ) : null}
      <div className={'builds-metric-tiles__tile-lines'}>
        <div className={`builds-metric-tiles__tile-lines--bold`}>{label}</div>
        <div
          className={`builds-metric-tiles__tile-lines--large ${valueClassName}`}
        >
          {value}
        </div>
      </div>
    </div>
  );
}

function BuildsMetricTiles({
  buildsMetricTiles,
}: BuildsMetricTilesViewModel): JSX.Element {
  return (
    <div className={'builds-metric-tiles'}>
      {buildsMetricTiles.map((buildsMetricTile) => (
        <BuildsMetricTile key={buildsMetricTile.label} {...buildsMetricTile} />
      ))}
    </div>
  );
}

export default BuildsMetricTiles;
